module.exports = __webpack_public_path__ + "img/FR41329.77a36574.png";